import { useState, useContext, useEffect } from "react";
import { ReactSelect } from "../../kits/Inputs/Inputs";

import useAxios from "../../../services/useAxios";
import { CustomInput } from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";

import FormulationListDefine from "./FormulationListDefine";
import {
  convertFormulToShow,
  translateToReactSelect,
} from "../../../utils/helperFunction";
export default function DefineFormulation({
  primaryServiceList,
  attributeProductList,
  attributeListReactSelect,
  addFormulation,
  changeFormulationData,
  data,
  formulationList,
  setFormulationList,
  attributeBaseOnProduct,
  setAttributeBaseOnProduct,
}) {
  const { execute: getProductPropertyListApi } = useAxios(
    "product/get_product_properties"
  );
  const [mathPreview, setMathPreview] = useState("");
  const [enterFormul, setEnterFormul] = useState([]);
  const [showFormul, setShowFormul] = useState("");
  // const [attributeBaseOnProduct, setAttributeBaseOnProduct] = useState([]);

  const attributeDefaultData = async (product_id) => {
    let arraySelect = [];

    await getProductPropertyListApi({ product_id: product_id }).then((res) => {
      arraySelect = res?.result
        ?.map((v, i) => {
          return {
            ...v,
            label: v?.title,
            value: v?.property_id,
            optionsList: v.options != "" ? v.options.split(",") : [],
          };
        })
        .reverse();

      setAttributeBaseOnProduct(arraySelect);
    });
  };
  useEffect(() => {
    let formulTemp = [];
    if (attributeBaseOnProduct.length > 0) {
      formulTemp = convertFormulToShow(
        data?.product?.inventory_formul ?? "",
        attributeBaseOnProduct
      );
      setShowFormul(formulTemp);
    }
  }, [attributeBaseOnProduct]);
  return (
    <div className="mathematic-style rounded px-2 py-4 shadow">
      <div className="react-select-style mb-3">
        <ReactSelect
          title="انتخاب ماده اولیه"
          itemsList={primaryServiceList}
          inputContainer=""
          inputSize="text"
          inputValue={data.product}
          onChangeFunc={(e) => {
            attributeDefaultData(e.id);
            setShowFormul("");
            changeFormulationData(e, "product");
          }}
          textErr={""}
        />
      </div>

      <FormulationListDefine
        mathPreview={mathPreview}
        setMathPreview={setMathPreview}
        enterFormul={enterFormul}
        setEnterFormul={setEnterFormul}
        formulationList={formulationList}
        setFormulationList={setFormulationList}
        title="تعریف فرمولها"
        attributeProductList={attributeListReactSelect}
        chooseMainProperty={data?.product?.type == 2 ? false : true}
        attributeBaseOnProduct={attributeBaseOnProduct}
      />
      {/* <div
        className="my-3 rounded border mx-auto  p-2"
        style={{ width: "95%", fontSize: 12, lineHeight: 1.8 }}
      >
        <h6 className="fw-bold">مقدار بازای هر واحد بر اساس فرمول مصرفی</h6>
        <span></span>
        <CustomInput
          id="titleTour"
          label={showFormul ?? "تعداد"}
          inputSize="text"
          type="text"
          inputContainer=""
          // inputValue={inputValue.count}
          inputValue={data.count_val}
          onChangeFunc={(e) => {
            changeFormulationData(e.target.value, "count_val");
          }}
        />
      </div> */}
      <div
        className="d-flex flex-wrap align-items-center mx-auto"
        style={{ width: "95%" }}
      >
        <div className="ms-2 my-1">
          <CustomInput
            label="الویت"
            inputSize="text"
            type="number"
            inputContainer=""
            inputClassName=""
            inputValue={data.priority}
            onChangeFunc={(e) =>
              changeFormulationData(e.target.value, "priority")
            }
            // textErr={validationTxt.answers}
          />
        </div>
        <div className="ms-2 my-1">
          <CustomInput
            label="کدگروه"
            inputSize="text"
            type="number"
            inputContainer=""
            inputClassName=""
            inputValue={data.group_code}
            onChangeFunc={(e) =>
              changeFormulationData(e.target.value, "group_code")
            }
            // textErr={validationTxt.answers}
          />
        </div>
        <div className="align-self-end ms-auto">
          <CustomButton
            color="success"
            size="medium"
            state={"normal"}
            circle={false}
            onClick={() => addFormulation()}
            // style={{ opacity: deactivateItems && "0.4" }}
          >
            ثبت نهایی
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
